import { render, staticRenderFns } from "./SpendDashboard.vue?vue&type=template&id=785f1fee&scoped=true&"
import script from "./SpendDashboard.vue?vue&type=script&lang=js&"
export * from "./SpendDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SpendDashboard.vue?vue&type=style&index=0&id=785f1fee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785f1fee",
  null
  
)

export default component.exports